run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','ExecutionIntegrationPanel','$cookies'];

//funcion donde se definen la run

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,ExecutionIntegrationPanel,$cookies ) {
	MenuConstant[0]['menu'].push(ExecutionIntegrationPanel);
           
               
}


// WEBPACK FOOTER //
// ./src/app/integration-front/integrationPanel.run.js